import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "status-flag-icon",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2 1.75C2 1.33579 2.33579 1 2.75 1H9.34375C9.75796 1 10.0938 1.33579 10.0938 1.75V5.98884C10.0938 6.40305 9.75796 6.73884 9.34375 6.73884H2.75C2.33579 6.73884 2 6.40305 2 5.98884C2 5.57463 2.33579 5.23884 2.75 5.23884H8.59375V2.5H2.75C2.33579 2.5 2 2.16421 2 1.75Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.75 1C3.16421 1 3.5 1.33579 3.5 1.75V9.7567C3.5 10.1709 3.16421 10.5067 2.75 10.5067C2.33579 10.5067 2 10.1709 2 9.7567V1.75C2 1.33579 2.33579 1 2.75 1Z"
    }, null, -1)
  ])))
}
export default { render: render }